<template>
  <div class="dataScreen">
    <div class="bg"></div>
    <div class="clock-bg"></div>
    <div style="z-index: 999">
      <div class="header">
        <div class="header-left">
          <div class="fullScreen" @click="changeScreenfull">
            <img src="../../assets/img/fullScreen-icon.png" alt="" class="icon" />
            <span>全屏展示</span>
          </div>
          <el-dropdown v-if="showCommunity && searchCommunityList && searchCommunityList.length" class="dropdown" trigger="click">
            <div class="selectedCommunityName">
              {{ selectedCommunityName }}
              <img src="../../assets/img/arrow-down.png" alt="" class="arrow" />
            </div>
            <el-dropdown-menu slot="dropdown" style="background-color: #051f58; border: 1px solid #254da1">
              <el-dropdown-item v-for="item in searchCommunityList" :key="item.communityId" @click.native="selectCommunity(item)">
                <span>{{ item.communityName }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="title">{{ companyName }}</div>
        <div class="time">{{ nowDate }}</div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import '@/utils/flexible'
import dayjs from 'dayjs'
import screenfull from 'screenfull'
import { getToken } from '@/utils/auth'
import { permissionCommunityDropList } from '@/api/dropList'

export default {
  name: 'ScreenHeader',
  props: {
    showCommunity: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCommunityName: '',
      selectedCommunityId: '',
      companyName: '',
      nowDate: '',
      timeInterval: '',
      isFullscreen: false,
      searchCommunityList: [],
    }
  },
  created() {
    this.init()
    this.timeInterval = setInterval(() => {
      this.nowDate = dayjs().format('YYYY 年 MM 月 DD 日  HH:mm')
    }, 1000)
  },
  beforeDestroy() {
    this.destroy()
    if (document.body) document.body.style.fontSize = '16px'
  },
  methods: {
    changeScreenfull() {
      if (!screenfull.isFullscreen && !screenfull.isEnabled) {
        return this.$msgbox({
          title: '全屏',
          message: '当前状态不能够进入全屏',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then(async action => {})
          .catch(action => {})
      }
      this.change()
      screenfull.toggle()
    },
    change() {
      this.isFullscreen = screenfull.isFullscreen
    },
    async init() {
      if (getToken()) {
        await this.$store.dispatch('user/getSealConfig')
        if (this.showCommunity) this.permissionCommunityDropList()
      }
      if (!this.showCommunity) {
        this.companyName = this.$store.getters.sealConfig.companyName
          ? this.$store.getters.sealConfig.companyName + '数据大屏'
          : this.$store.getters.organizationInfo.organizationName + '数据大屏'
      }
      if (screenfull.isEnabled) {
        screenfull.on('change', this.change)
      }
    },

    // 获取小区
    async permissionCommunityDropList() {
      const { data } = await permissionCommunityDropList()
      this.searchCommunityList = data || []
      if (data.length) {
        this.selectedCommunityName = this.searchCommunityList[0].communityName
        this.selectedCommunityId = this.searchCommunityList[0].communityId
        this.companyName = `${this.searchCommunityList[0].communityName}数据大屏`
        this.$emit('selectCommunity', this.selectedCommunityId)
      }
    },

    // 切换小区
    selectCommunity(item) {
      this.selectedCommunityId = item.communityId
      this.selectedCommunityName = item.communityName
      this.companyName = `${item.communityName}数据大屏`
      this.$emit('selectCommunity', item.communityId)
    },
    destroy() {
      if (screenfull.isEnabled) {
        screenfull.off('change', this.change)
      }
      if (this.timeInterval) {
        clearInterval(this.timeInterval)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/charts.scss';
.dataScreen {
  min-width: 1400px;
  min-height: 100vh;
  position: relative;
  font-family: 'HarmonyOSSansSCMedium' !important;
  overflow: hidden;
  .selectedCommunityName {
    cursor: pointer;
  }
  .mb-16 {
    margin-bottom: vh(16);
  }
  .mb-17 {
    margin-bottom: vh(17);
  }
  .mb-18 {
    margin-bottom: vh(18);
  }
  .mb-22 {
    margin-bottom: vh(22);
  }
  .mb-34 {
    margin-bottom: vh(34);
  }
  .mb-38 {
    margin-bottom: vh(38);
  }
  .mb-40 {
    margin-bottom: vh(40);
  }
  .mb-32 {
    margin-bottom: vh(32);
  }
  .mb-10 {
    margin-bottom: vh(10);
  }
  .mb-27 {
    margin-bottom: vh(27);
  }
  .mb-4 {
    margin-bottom: vh(4);
  }
  .mr-8 {
    margin-right: vw(8);
  }
  .ml-50 {
    margin-left: vw(50);
  }
  .ml-14 {
    margin-left: vw(14);
  }
  .mr-4 {
    margin-right: vw(4);
  }
  .mt-20 {
    margin-top: vh(20);
  }
  .mt-32 {
    margin-top: vh(32);
  }
  .mt-4 {
    margin-top: vw(4);
  }
  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .mb-3 {
    margin-bottom: vh(3);
  }
  .flex-auto {
    flex: 1;
  }
  .bg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background-image: url('../../assets/img/company-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: -2;
  }
  .clock-bg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: vh(858);
    height: vh(858);
    background-image: url('../../assets/img/company-bg-2.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    z-index: -1;
  }
  .header {
    position: relative;
    width: 100%;
    height: vh(73.25);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-image: url('../../assets/img/header-bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: rem(15);
    color: #74a1e3;
    padding: vh(15) vw(32) vh(25);
    .header-left {
      display: flex;
      .dropdown {
        font-size: rem(15);
        color: #74a1e3;
        margin-left: vw(45);
        .arrow {
          width: vw(16);
          height: vw(16);
          vertical-align: bottom;
        }
      }
    }
    .title {
      position: absolute;
      bottom: 34%;
      left: 50%;
      transform: translateX(-50%);
      font-size: rem(24);
      font-family: 'HarmonyOSSansSCBold';
      background: linear-gradient(180deg, #ffffff 0%, #89cef4 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
    }
    .fullScreen {
      font-size: rem(15);
      cursor: pointer;
      .icon {
        width: vw(16);
        height: vw(16);
        vertical-align: bottom;
      }
    }
  }
}
::v-deep .el-dropdown-menu__item {
  color: #74a1e3 !important;
}

::v-deep .el-dropdown-menu__item:hover {
  background-color: #032367 !important;
}

::v-deep .popper__arrow::after {
  border-bottom-color: #051f58 !important;
}
::v-deep .popper__arrow,
.popper__arrow::after {
  border-bottom-color: #254da1 !important;
}
</style>
